import React, { useEffect, useState } from 'react';
import { useTranslation } from '$shared/utils';
import { ButtonPropsLegacy, RouterLink } from '$shared/components';
import { useMedia } from 'react-use';
import { queries } from '$theme';
import { StyledLoadNextPageButton } from './styled';
import { ConditionalWrap } from '~/shared/utils/jsx';

type Props = {
    disabled: boolean;
    url: string;
};

const LoadNextPageButton = ({ disabled, url }: Props) => {
    const { translate } = useTranslation();
    const [buttonStyle, setButtonStyle] = useState({ size: 'lg' } as ButtonPropsLegacy);
    const isMobile = !useMedia(queries.md, false);
    const conditionalProps = disabled ? {} : { href: url };

    useEffect(() => {
        setButtonStyle({ size: isMobile ? 'md' : 'lg' } as ButtonPropsLegacy);
    }, [isMobile, setButtonStyle]);

    return (
        <ConditionalWrap
            if={!disabled}
            wrap={(children) => <RouterLink href={url}>{children}</RouterLink>}
            children={
                <StyledLoadNextPageButton
                    isDisabled={disabled}
                    showHoverIndicator={!disabled}
                    variant="secondary"
                    as="a"
                    {...conditionalProps}
                    {...buttonStyle}
                >
                    {!isMobile ? translate('general.next') : '>'}
                </StyledLoadNextPageButton>
            }
        />
    );
};

export const LoadNextPage = LoadNextPageButton;
